import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ConfigService } from './services/config/config.service';
import { ApplicationEventsService } from './services/application-events/application-events.service';
import { ErrorsService } from './services/errors-service/errors.service';
import packageJson from 'package.json';
import { Validators } from '@angular/forms';
import { UtilsService } from './services/utils/utils.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements AfterViewInit, OnInit {
  public title = 'poultry-sense-client';

  public isShowErrorModal: boolean = false;

  constructor(
    public configService: ConfigService,
    public errorsService: ErrorsService,
    public utilsService: UtilsService,
    private readonly applicationEventsService: ApplicationEventsService,
  ) {}

  public ngOnInit() {
    this.errorsService.isShowError$.subscribe((value) => {
      this.isShowErrorModal = value;
    });
    console.log('App Version:', packageJson.version);

    // software mechanism for marking required fields in a reactive form group
    this.utilsService.markRequiredFields.subscribe((value) => {
      if (value.elements.length > 0 && value.formGroup) {
        // take native element by form controls name and if control have required validator - add 'required' class to them
        document.querySelectorAll(value.elements.join(', ')).forEach(input => {
          const controlName = input.getAttribute('formControlName');
          if (
            controlName &&
            value.formGroup.get(controlName) &&
            value.formGroup.get(controlName).hasValidator(Validators.required)
          ) {
            const labelElement = input.parentElement.parentElement.getElementsByClassName(value.classes.join(', '));
            if (labelElement && labelElement.length > 0) {
              labelElement[0].classList.add('required-field');
            }
          }
        });
      }
    });
  }

  public closeErrorModal() {
    this.errorsService.isShowError$.next(false);
    this.isShowErrorModal = false;
  }

  public ngAfterViewInit(): void {
    this.applicationEventsService.afterAppInitSubject.next();
  }
}
